import { Dispatch, ReactNode, createContext, useReducer, useContext } from 'react'

import metaReducer, { initState } from './reducer'
import { MetaState, MetaAction } from './types'
import { setMeta } from './actions'
import Component from './component'

const MetaContext = createContext<[MetaState, Dispatch<MetaAction>]>([initState, () => {}])

export const MetaProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}: {
	children: ReactNode
}) => {
	const value = useReducer(metaReducer, initState)

	return (
		<MetaContext.Provider value={value}>
			<Component>{children}</Component>
		</MetaContext.Provider>
	)
}

export const useMeta = (): [MetaState, Record<string, any>] => {
	const context = useContext(MetaContext)
	if (context === undefined) {
		throw new Error('[Meta] useMeta must be used within MetaProvider.')
	}
	const [state, dispatch] = context

	const dispatchActions = {
		setMeta: setMeta(dispatch),
	}

	return [state, dispatchActions]
}
